export const COMPANY_STATE_LIST = 'COMPANY_STATE_LIST';
export const HISAB_REPORT_DROP_DATA = 'HISAB_REPORT_DROP_DATA';
export const HISAB_REPORT_SUMMARY_DATA = 'HISAB_REPORT_SUMMARY_DATA';
export const HISAB_REPORT_DETAILED_DATA = 'HISAB_REPORT_DETAILED_DATA';